import type { Service } from "#app/store/RTK/slices/servicesSlice";

/**
 * Иммутабельный мутаторм для списка услуг:
 * либо обновляет существующую запись, либо добавляет новую в начало списка.
 */
export const upsertServiceInList = (services: Service[], updated: Service): Service[] => {
    const index = services.findIndex((s) => s.id === updated.id);
    if (index === -1) {
        return [updated, ...services];
    }
    return services.map((s, i) => (i === index ? updated : s));
};
